var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoi = function SvgInfoi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1595"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-652)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeWidth: 1.6,
    "data-name": "Ellipse 6582",
    transform: "translate(655 3)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M664 16v-4",
    "data-name": "Line 116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    fill: props.color || 'currentColor',
    "data-name": "Ellipse 6583",
    transform: "translate(663 7.5)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoi);
export default ForwardRef;